// Verbatim slug generator from spec
export function slugify(name) {
  if (!name) return "";
  const nfkd = name.normalize("NFKD");
  const noDiacritics = nfkd.replace(/[\u0300-\u036f]/g, "");
  const noApostrophes = noDiacritics.replace(/[\u2019']/g, "");
  const lower = noApostrophes.toLowerCase();
  const dashed = lower.replace(/[^a-z0-9]+/g, "-");
  return dashed.replace(/^-+|-+$/g, "").slice(0, 64);
}
